import { WidgetPreviewRequest, WidgetPreviewResponse } from './types';

import { http } from '../../http';

export const widgetPreview = async (req: WidgetPreviewRequest, signal?: AbortSignal) => {
    const data = await http.post<WidgetPreviewRequest, WidgetPreviewResponse>(
        '/widget/preview',
        req,
        { signal }
    );
    return data;
};
